import type { AuthUser } from "./types";
import { normalizePermissionList } from "./permissions";

export const normalizeAuthUser = (value: Partial<AuthUser> | null | undefined): AuthUser | null => {
    if (!value?.userId || !value.email || !value.role) {
        return null;
    }

    const firstName = value.firstName?.trim() ?? "";
    const lastName = value.lastName?.trim() ?? "";
    const computedFullName = `${firstName} ${lastName}`.trim();

    return {
        userId: value.userId,
        role: value.role,
        firstName,
        lastName,
        fullName: value.fullName?.trim() || computedFullName || value.email,
        email: value.email,
        emailVerified: Boolean(value.emailVerified),
        status: value.status ?? "ACTIVE",
        permissions: normalizePermissionList(value.permissions, value.role),
        effectivePermissions: normalizePermissionList(
            value.effectivePermissions ?? value.permissions,
            value.role
        ),
    };
};
